import React from 'react';
import LogoIcon from './logo-icon';
import GreyLogoIcon from './grey-logo-icon';
import CloseIcon from './close';
import UserIcon from './user';
import GameIcon from './game';
import DividerIcon from './divider';
import ArrowLeftIcon from './arrowLeft';
import ShareIcon from './share';
import CopyIcon from './copy';
import ArrowRightIcon from './arrowRight';
import SearchIcon from './search';
import MenuIcon from './menu';
import UsersIcon from './users';
import SortIcon from './sortIcon';
import CalendarIcon from './calendar';
import SandClockIcon from './sandClock';
import WatchIcon from './watch';
import ArrowDownIcon from './arrowDown';
import CubeIcon from './cube';

export const iconTypes = {
  logo: <LogoIcon />,
  greyLogo: <GreyLogoIcon />,
  close: <CloseIcon />,
  user: <UserIcon />,
  game: <GameIcon />,
  divider: <DividerIcon />,
  arrowLeft: <ArrowLeftIcon />,
  share: <ShareIcon />,
  copy: <CopyIcon />,
  arrowRight: <ArrowRightIcon />,
  search: <SearchIcon />,
  menu: <MenuIcon />,
  users: <UsersIcon />,
  sort: <SortIcon />,
  calendar: <CalendarIcon />,
  sandClock: <SandClockIcon />,
  watch: <WatchIcon />,
  arrowDown: <ArrowDownIcon />,
  cube: <CubeIcon />,
};
